import { FILTERS, STRIP_IDS } from "@/data/shopFilters";
import { SectionTitle } from "@/components/Wave";
import { ProductCard, ShipLine } from "@/components/ProductCard";

export const ShopCard = ProductCard;

export const FilterBar = ({ active, onChange }) => (
  <div data-testid="shop-filters" role="group" aria-label="Filter products by category" className="mt-8 flex flex-wrap gap-2">
    {[{ key: "", label: "All" }, ...FILTERS].map((f) => (
      <button key={f.key || "all"} type="button" data-testid={`filter-${f.key || "all"}`} aria-pressed={active === f.key} onClick={() => onChange(f.key)}
        className={`rounded-full border-2 border-navy px-5 py-2 text-sm font-bold transition-colors ${active === f.key ? "bg-navy text-sand" : "bg-sand text-navy hover:bg-foam"}`}>
        {f.label}
      </button>
    ))}
  </div>
);

export const FilterResults = ({ products, active }) => {
  const f = FILTERS.find((x) => x.key === active);
  const list = products.filter((p) => f.ids.includes(p.id) && !p.coming_soon);
  return (
    <div data-testid={`filter-results-${active}`} className="container-gf section pt-8">
      <p className="text-sm text-slate-600"><span data-testid="filter-results-count">{list.length}</span> products in {f.label}</p>
      <ShipLine list={list} testId={`ship-line-filter-${active}`} />
      <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">{list.map((p) => <ProductCard key={p.id} p={p} />)}</div>
    </div>
  );
};

export const StripsRow = ({ products }) => {
  const strips = products.filter((p) => STRIP_IDS.includes(p.id) && p.active && !p.coming_soon);
  if (!strips.length) return null;
  return (
    <div data-testid="shop-strips" className="border-t border-navy/10">
      <div className="container-gf section">
        <SectionTitle chip="On the go" title="Grab-and-go strips" sub="Oral strips that melt on your tongue. No water, no capsules." />
        <ShipLine list={strips} testId="ship-line-strips" />
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{strips.map((p) => <ProductCard key={p.id} p={p} />)}</div>
      </div>
    </div>
  );
};
